export default "__VITE_ASSET__qjLPl_Mk__"